var _excluded = ["error", "name", "label", "id", "defaultValue", "disabled", "maxWidth"];

function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import { Box } from "grommet";
import { StyledTextInput, StyledIconSvg, StyledFormField, StyledBox } from "./styles";
export var PasswordInput = function PasswordInput(_ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? "" : _ref$error,
    name = _ref.name,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Введите пароль" : _ref$label,
    id = _ref.id,
    defaultValue = _ref.defaultValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "406px" : _ref$maxWidth,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/ React.createElement(
    Box,
    {
      flex: true,
      width: {
        max: maxWidth,
      },
    },
    /*#__PURE__*/ React.createElement(
      StyledFormField,
      {
        error: error,
        disabled: disabled,
        htmlFor: id,
      },
      error.length ? error : label
    ),
    /*#__PURE__*/ React.createElement(
      StyledBox,
      null,
      /*#__PURE__*/ React.createElement(StyledIconSvg, {
        error: error,
        disabled: disabled,
        src: "passwordKey",
        width: "18",
        height: "16",
        color: "#737373",
      }),
      /*#__PURE__*/ React.createElement(
        StyledTextInput,
        _extends(
          {
            focusIndicator: true,
            plain: true,
            type: "password",
            error: error,
            disabled: disabled,
            defaultValue: defaultValue,
            name: name,
            id: id,
          },
          rest
        )
      )
    )
  );
};
